import React from 'react';
import { usePortion, usePreviousQuantity } from './hooks';
import {
  AddIcon,
  Container,
  MinimizeQuantityNumber,
  QuantityButton,
  QuantityButtonWrapper,
  QuantityContainer,
  QuantityNumber,
  QuantityNumberContainer,
  QuantityWrapper,
  SubstractIcon,
} from './styles';
import { PortionType } from './types';

export const Portion: React.FC<PortionType> = (props) => {
  const {
    containerProps,
    decrementButtonProps,
    incrementButtonProps,
    quantity = 0,
    isMax,
    isMin,
    minimize,
    showButtonValue,
  } = usePortion(props);

  const { currentQuantity, hasChanged, previousQuantity } = usePreviousQuantity({ quantity });
  const hideQuantity = previousQuantity === 0 || currentQuantity === previousQuantity;
  const quantityContainerProps = {
    $animate: hasChanged,
    $hide: hideQuantity,
  };

  return (
    <Container {...containerProps}>
      <QuantityButton {...decrementButtonProps} data-cy='quick-add-dec-btn'>
        <QuantityButtonWrapper>
          <SubstractIcon disabled={isMin} />
        </QuantityButtonWrapper>
      </QuantityButton>
      <QuantityContainer minimize={minimize}>
        <QuantityWrapper>
          <QuantityNumber hidden>{quantity}</QuantityNumber>
          {!showButtonValue && (
            <QuantityNumberContainer {...quantityContainerProps}>
              <QuantityNumber>{quantity}</QuantityNumber>
            </QuantityNumberContainer>
          )}
        </QuantityWrapper>
      </QuantityContainer>
      <QuantityButton {...incrementButtonProps} data-cy='quick-add-inc-btn'>
        <QuantityButtonWrapper $highlight={showButtonValue}>
          {showButtonValue ? <MinimizeQuantityNumber>{quantity}</MinimizeQuantityNumber> : <AddIcon disabled={isMax} />}
        </QuantityButtonWrapper>
      </QuantityButton>
    </Container>
  );
};
